import AttributeSegmentationLink from 'app/components/Core/CategorySegment/AttributeSegmentation/Link'
import KItem from 'app/components/Modules/General/KItem'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import React, { ComponentProps } from 'react'

import { MemberProps } from '../convention'
import LineItemImage from '../LineItem/Image'

const CategorySegmentListItem: React.FC<
  MemberProps<ICategorySegment, ComponentProps<typeof KItem>>
> = ({ member: categorySegment, props }) => {
  const { tRecordType } = useTranslation({ recordType: RecordTypeEnum.categorySegment })
  return (
    <KItem
      avatar={<LineItemImage member={categorySegment} props={{ width: 80 }} />}
      title={<span className="h4">{categorySegment.name}</span>}
      description={
        <If condition={categorySegment.hasAttributeSegmentations}>
          <AttributeSegmentationLink member={categorySegment}>
            {tRecordType({ id: 'tech_details' })}
          </AttributeSegmentationLink>
        </If>
      }
      {...props}
    />
  )
}

export default CategorySegmentListItem
